<div class="container">
  @if (isOrganizationView()) {
    <fdr-past-performance-ui-performance-chart
      [performanceData]="sitePerformanceData()"
      [isLoading]="siteLoading()"
      [labelAccessor]="siteLabelAccessor">
    </fdr-past-performance-ui-performance-chart>
  } @else {
    <fdr-past-performance-ui-performance-chart
      [performanceData]="productPerformanceData()"
      [isLoading]="productLoading()"
      [labelAccessor]="productLabelAccessor()">
    </fdr-past-performance-ui-performance-chart>
  }
</div>
